import request from './request'

const http = {
  /**
   * GET 请求
   * @param {string} url 地址
   * @param {object} params 参数
   */
  get(url, params) {
    return request({
      url: url,
      method: 'get',
      params: params
    })
  },

  /**
   * POST 请求
   * @param {string} url 地址
   * @param {object} data 数据对象
   */
  post(url, data) {
    return request({
      url: url,
      method: 'post',
      data: data
    })
  }
}

export default http
